import PropTypes from 'prop-types';
import classNames from 'classnames';

const VenueContentBlock = ({ title, children }) => {
  const classes = classNames({
    'venue-content-block': true,
    'venue-content-block--clinical': title === 'Clinical rooms',
    'venue-content-block--non-clinical': title === 'Non-Clinical rooms',
  });

  return (
    <div className={classes}>
      <div className="venue-content-block__container">
        <h3 className="venue-content-block__title">{title}</h3>
        <div className="venue-content-block__content">{children}</div>
      </div>
    </div>
  );
};

VenueContentBlock.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
};

export default VenueContentBlock;
